//------------ REACT IMPORT --------------//
import React from "react";
//---------- FONTAWESOME IMPORT ----------//
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//--------- BOOTSTRAP ITEMS IMPORT ----------//
import { Col, Dropdown, Image, Row } from "react-bootstrap";
//------------ IMAGES IMPORT ---------------//
import { Card1, Delete_2, Edit_2, Eye_2, Group, MytaskImg, User1, User2 } from "../../../../assets/images";

const Task = () => {
    return (
        <div className="card_section">
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                    <div className="card_area">

                        {/* //------------ my tasks screen area content ---------------// */}
                        <div className="mytask_area">
                            <div className="mytask_left_area">
                                <div className="img_area">
                                    <Image src={MytaskImg} alt="..." />
                                </div>
                                <div className="right_name_area">
                                    <p>Willia Jayden</p>
                                    <p><span>MR - 457124</span></p>
                                </div>
                            </div>
                            <div className="mytask_right_area">
                                <p><span>Cardiology</span></p>
                            </div>
                        </div>

                        <div className="sub_title">
                            <div className="left_area">
                                <p>11 june 2023  11:00AM</p>
                            </div>
                            <div className="right_area">
                                <p>Complete</p>
                            </div>
                        </div>
                        <div className="card_inner">
                            <div className="card_inner_detail">
                                <div className="sub_title">
                                    <div className="left_area">
                                        <p>High</p>
                                    </div>
                                    <div className="task_right_area">
                                        <p>Completed</p>
                                    </div>
                                </div>
                                <div className="title_area">
                                    <h5> Diagnosing and Treating</h5>
                                </div>
                                <div className="description">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit. Etiam sem orc
                                    </p>
                                    <p> <span>10:30 AM to 11:00 AM</span> </p>
                                </div>
                                <div className="group_image">
                                    <div className="image_area">
                                        <Image src={User1} alt="..." />
                                    </div>
                                    <div className="image_area img_2">
                                        <Image src={User2} alt="..." />
                                    </div>
                                    <a href="javascript:;">
                                        <div className="image_area img_3">
                                            <p>3+</p>
                                        </div>
                                    </a>

                                </div>
                            </div>
                            <div className="bottom_area">
                                <div className="inner_area">
                                    <div className="left_area">
                                        <div className="img_area">
                                            <Image variant="left" src={Card1} alt="..." />
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="name_area">
                                            <h3>Robert William</h3>
                                            <p>Consultant</p>


                                            <Dropdown>
                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item href="javascript:;">
                                                        Completed
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javascript:;">
                                                        Pending
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                    <div className="card_area">
                        <div className="mytask_area">
                            <div className="mytask_left_area">
                                <div className="img_area">
                                    <Image src={MytaskImg} alt="..." />
                                </div>
                                <div className="right_name_area">
                                    <p>Willia Jayden</p>
                                    <p><span>MR - 457124</span></p>
                                </div>
                            </div>
                            <div className="mytask_right_area">
                                <p><span>Cardiology</span></p>
                            </div>
                        </div>
                        <div className="sub_title">
                            <div className="left_area">
                                <p>11 june 2023  11:00AM</p>
                            </div>
                            <div className="right_area test">
                                <p>Pending</p>
                            </div>
                        </div>
                        <div className="card_inner pending">
                            <div className="card_inner_detail">
                                <div className="sub_title">
                                    <div className="left_area testt">
                                        <p>Low</p>
                                    </div>
                                    <div className="task_right_area pending">
                                        <p>Pending</p>
                                    </div>
                                </div>
                                <div className="title_area">
                                    <h5> Diagnosing and Treating</h5>
                                </div>
                                <div className="description">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit. Etiam sem orc </p>
                                    <p> <span>10:30 AM to 11:00 AM</span> </p>
                                </div>
                                <div className="group_image">
                                    <div className="image_area">
                                        <Image src={User1} alt="..." />
                                    </div>
                                    <div className="image_area img_2">
                                        <Image src={User2} alt="..." />
                                    </div>
                                    <a href="javascript:;">
                                        <div className="image_area img_3">
                                            <p>3+</p>
                                        </div>
                                    </a>

                                </div>
                            </div>
                            <div className="bottom_area">
                                <div className="inner_area">
                                    <div className="left_area">
                                        <div className="img_area">
                                            <Image variant="left" src={Card1} alt="..." />
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="name_area">
                                            <h3>Robert William</h3>
                                            <p>Consultant</p>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item href="javascript:;">
                                                        Completed
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javascript:;">
                                                        Pending
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default Task;